import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useForm } from "react-hook-form";
import CommonForm from "Components/Common/CommonForm";
import { volunteerTestColumn } from "../helper/volunteertest.constant";
import { useVolunteerTest } from "../api/useVolunteerTest";
import { queryClient } from "api/queryClient";
import { GetUserData, showToastMessage } from "common/service/CommonService";
import { useNavigate, useParams } from "react-router-dom";
import Reason from "common/utilities/Reason/Reason";
import { getLabelFromValue } from "helpers/constant";
import { AlcoholResult_OPTIONS } from "api/modules/common.option";
import { VOLUNTEER_PATHS } from "Routes/paths";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  editData?: any;
  isEditMode?: boolean;
  volunteerid?: number | string | null;
  studyid?: number | null;
  alcoholstage?: string;
  modulename?: string;
}

const AddAlcoholTestModal: React.FC<Props> = ({
  isOpen,
  toggle,
  editData,
  isEditMode,
  volunteerid: volunteeridProp,
  studyid: studyidProp = null,
  alcoholstage: alcoholstageProp = "Volunteer",
  modulename
}) => {
  const { control, handleSubmit, setValue, reset, formState: { errors } } = useForm({
    defaultValues: {
      bac: null,
      alcoholunit: "mg/dL",
      alcoholresult: "Positive",
      indicatorlightcolor: "",
      testdate: new Date(),
      alcoholtestedby: null
    }
  });

  useEffect(() => {
    if (isEditMode && editData && isOpen) {
      setValue("bac", editData.bac);
      setValue("alcoholunit", editData.alcoholunit);
      setValue("alcoholresult", editData.alcoholresult);
      setValue("indicatorlightcolor", editData.indicatorlightcolor ?? "");
    }
    else {
      reset();
    }
  }, [editData, isEditMode, isOpen]);

  const { id: paramId } = useParams();
  const volunteerid = volunteeridProp ?? paramId;
  const navigate = useNavigate()

  const { InsertMutation, UpdateMutation } = useVolunteerTest({});

  const onSubmit = (data: any) => {

    if (isEditMode) {
      setIsReasonOpen(true);
      setPendingData(data);
      return;
    } else {

      const payload = {
        volunteerid: volunteerid,
        alcoholstage: alcoholstageProp,
        studyid: studyidProp,
        bac: data.bac,
        alcoholunit: data.alcoholunit,
        alcoholresult: data.alcoholresult,
        indicatorlightcolor: data.indicatorlightcolor,
        createdby: GetUserData()?.userid,
        modulename:modulename
      }
      const result = getLabelFromValue(AlcoholResult_OPTIONS, data.alcoholresult)

      InsertMutation.mutate(payload, {
        onSuccess: (res: any) => {
          // if (result.toLowerCase() == "positive") {
          //   navigate(VOLUNTEER_PATHS.DETAILS.replace(":id", String(volunteerid)));
          // }
          queryClient.invalidateQueries({ queryKey: ["volunteer-test-count"] });
          queryClient.invalidateQueries({ queryKey: ["volunteer-alcohol-test-result"] });
          
          showToastMessage("success", res.message);
          handleClose();
        },
        onError: (error: any) => {
          showToastMessage("error", error);
        },
      });
    }
  };


  const [pendingData, setPendingData] = useState<any>(null);
  const [isReasonOpen, setIsReasonOpen] = useState(false);

  const handleClose = () => {
    reset();
    toggle();
  };

  const handleUpdateWithReason = ({ reason }: { reason: string }) => {
    if (!pendingData) return;
    const payload = {
      alcoholtestid: editData?.alcoholtestid,
      volunteerid: volunteerid,
      alcoholstage: alcoholstageProp,
      studyid: studyidProp,
      bac: pendingData.bac,
      alcoholunit: pendingData.alcoholunit,
      alcoholresult: pendingData.alcoholresult,
      indicatorlightcolor: pendingData.indicatorlightcolor,
      updatedby: GetUserData()?.userid,
      updatereason: reason,
      modulename: modulename
    }
    const result = getLabelFromValue(AlcoholResult_OPTIONS, pendingData.alcoholresult)

    UpdateMutation.mutate(payload,
      {
        onSuccess: (res:any) => {
          // if (result.toLowerCase() == "positive") {

          //   navigate(`/volunteer/details/${volunteerid}`, {
          //     replace: true,
          //   });

          // }

          queryClient.invalidateQueries({ queryKey: ["volunteer-alcohol-test-result"] });
          showToastMessage("success", res.message);

          setIsReasonOpen(false);
          setPendingData(null);

          handleClose();
        },
        onError: (err: any) => {
          showToastMessage("error", err.message);
        },
      },
    );
  };

  return (
    <Modal isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      backdrop
      className="common_modal">
      <ModalHeader toggle={toggle} className="p-3">
        Add Alcohol Test Record
      </ModalHeader>
      <ModalBody className="p-4">
        <CommonForm
          columns={3}
          control={control}
          errors={errors}
          fields={volunteerTestColumn}
        />
      </ModalBody>
      <ModalFooter className="bg-white border-top">
        <Button color="dark" onClick={toggle} outline>Cancel</Button>
        <Button
          color="primary"
          outline
          onClick={handleSubmit(onSubmit)}
          disabled={InsertMutation.isPending}
        >
          {InsertMutation.isPending ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Uploading...
            </>
          ) : isEditMode ? (
            "Update"
          ) : (
            "Upload"
          )}
        </Button>
      </ModalFooter>

      <Reason
        isOpen={isReasonOpen}
        toggle={() => setIsReasonOpen(false)}
        action="Update"
        id={editData?.alcoholtestid}
        click={({ reason }) => handleUpdateWithReason({ reason })}
        isLoading={UpdateMutation.isPending}
      />
    </Modal>
  );
};

export default AddAlcoholTestModal;
